import React, { useState } from "react";
import {
  GeneralErrors,
  GeneralValidators,
  useInputHandler,
} from "hooks/useInputHandler";
import { Button, ButtonSize, SelectableField, TextField } from "@bale/ui";
import Footer from "../../../commons/footer/Footer";
import Header from "../../../commons/header/Header";
import styles from "./Register.module.scss";
import commonStyles from "../Login.module.scss"; //styles that are common in initial pages (phone,otp,register)
import classNames from "classnames";
import { strings } from "intl/fa";
import { useRequest } from "../../../../hooks/useRequest";
import { registerPanelThunk } from "../../../../core/auth/auth.thunk";
import { AccountType } from "../../../../core/auth/auth.entity";
import { useAppDispatch } from "../../../../utils/store";
import { AuthActions, AuthState } from "../../../../core/auth/auth.slice";
import Modal, { ModalType } from "../../../commons/modal/Modal";
import { sendYandexGoal, YandexGoal } from "../../../../yandex/yandex";

type Props = {
  baleSignUp?: boolean;
};
const Register: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const dispatch = useAppDispatch();
  const { sendRequest, loading } = useRequest(registerPanelThunk);
  const [showBaleSignUpModal, setShowBaleSignUpModal] = useState(false);
  const [registerDelayLoading, setRegisterDelayLoading] = useState(false);
  const ownerName = useInputHandler({
    rules: [GeneralValidators.required],
    errorMessages: {
      [GeneralErrors.Required]: strings.common.error.required,
    },
  });
  const organizationName = useInputHandler({
    rules: [GeneralValidators.required],
    errorMessages: {
      [GeneralErrors.Required]: strings.common.error.required,
    },
  });
  const [userType, setUserType] = useState<AccountType | undefined>(
    AccountType.Personal
  );
  const isValidForm =
    !ownerName.error &&
    ownerName.value &&
    userType &&
    (userType === AccountType.Personal ||
      (!organizationName.error && organizationName.value));

  const handleSubmit = () => {
    if (isValidForm) {
      sendRequest({
        type: userType,
        name: organizationName.rawValue,
        owner_name: ownerName.rawValue,
        signUpBale: Boolean(props.baleSignUp),
        onSuccess: (res) => {
          if (res) {
            if (props.baleSignUp) {
              setShowBaleSignUpModal(true);
            } else {
              dispatch(AuthActions.setAuthState(AuthState.Success));
            }
          }
        },
      });
      if (props.baleSignUp) {
        sendYandexGoal(YandexGoal.SignUpBtn);
      } else {
        sendYandexGoal(YandexGoal.RegisterBtn);
      }
    }
  };
  return (
    <>
      <div className={commonStyles.wrapper}>
        <Header className={styles.header} title={strings.register.title} />
        <div className={styles.wrapper}>
          <TextField
            label={strings.register.name.label}
            placeholder={strings.register.name.placeholder}
            dir={"rtl"}
            {...ownerName}
          />
          <div className={styles.description}>
            {strings.register.description}
          </div>
          <div className={styles.userTypes}>
            <SelectableField
              name={strings.register.userType.natural}
              value={strings.register.userType.natural}
              selected={userType === AccountType.Personal}
              onChange={() => setUserType(AccountType.Personal)}
            />
            <SelectableField
              name={strings.register.userType.legal}
              value={strings.register.userType.legal}
              selected={userType === AccountType.Organization}
              onChange={() => setUserType(AccountType.Organization)}
            />
          </div>
          {userType === AccountType.Organization && (
            <TextField
              label={strings.register.business.label}
              placeholder={strings.register.business.placeholder}
              dir={"rtl"}
              {...organizationName}
            />
          )}
        </div>
      </div>
      {showBaleSignUpModal && (
        <Modal
          title={strings.register.signup_modal.title}
          primaryLoading={registerDelayLoading}
          primaryButton={{
            onClick: () => {
              setRegisterDelayLoading(true);
              setTimeout(() => {
                dispatch(AuthActions.setAuthState(AuthState.Success));
              }, 1000);
            },
            label: strings.register.signup_modal.go_to_panel,
          }}
          type={ModalType.Success}
          onClose={() => {}}
          content={strings.register.signup_modal.content}
        />
      )}
      <Footer className={classNames(commonStyles.wrapper, commonStyles.footer)}>
        <Button
          text={strings.common.button.submit_and_continue}
          size={ButtonSize.XLarge}
          disable={!isValidForm}
          loading={loading}
          onClick={handleSubmit}
        />
      </Footer>
    </>
  );
};

export default Register;
